export const FrontEndRoutes = {
  INDEX: '/',
  HOME: '/',
  SERVICES: '/services',
  TEAM: '/team',
  ABOUT: '/about',
  CONTACT: '/contact',
  LANDING: '/:slug',
  GALLERY: '/gallery',
  LOCATION: '/location',
};
